import React from "react";
import { css, cx } from "emotion";
import { headerStyle } from "./style";

const PanelHeader = ({ className, children }) => {
	return (
		<div
			className={cx(
				css`
					${headerStyle}
				`,
				className
			)}
		>
			{children}
		</div>
	);
};

export default PanelHeader;
